<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          :data="configurationsData"
          :description="false"
          search
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading1">
              {{ $t("system.label.GlobalConfiguration") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="createConfigurationPopup = true"
                size="small"
                >{{ $t("Add Configuration") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <th>{{ $t("system.label.Module") }}</th>
            <th width="15%">{{ $t("system.label.Name") }}</th>
            <th>
              <div style="width: 250px">
                {{ $t("system.label.Description") }}
              </div>
            </th>
            <th>{{ $t("system.label.Value") }}</th>
            <th>{{ $t("system.label.Enabled") }}</th>
            <th class="tHeadCenter">
              {{ $t("system.label.Action") }}
            </th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="configurationsData"
              v-for="(configurationsData, index) in data"
            >
              <vs-td :data="configurationsData.module">{{
                configurationsData.module
              }}</vs-td>
              <vs-td :data="configurationsData.name">{{
                configurationsData.name
              }}</vs-td>
              <vs-td :data="configurationsData.description" class="width15">{{
                configurationsData.description
              }}</vs-td>
              <vs-td :data="configurationsData.value" class="width15">{{
                configurationsData.value
              }}</vs-td>
              <vs-td :data="configurationsData.enabled"
                ><vs-switch
                  v-model="configurationsData.enabled"
                  @change="
                    updateFlag(
                      configurationsData.id,
                      configurationsData.enabled
                    )
                  "
              /></vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('system.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editGlobalConfigValue(configurationsData)"
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('system.label.AddConfiguration')"
        :active.sync="createConfigurationPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Name')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="name"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.Enabled") }}
                  <span class="required"> *</span></small
                >
                <v-select
                  :options="enabledOptions"
                  v-model="enabled"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Value')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="value"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('system.label.Module')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="module"
              />
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mt-4"
            >
              <vs-input
                :label="$t('system.label.Description')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="description"
              />
            </div>
          </div>
          <div class="vx-row center my-4">
            <div class="vx-col w-full">
              <vs-button
                color="primary"
                class="footerButton-next mb-5"
                @click="discountTrigger"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('system.label.EditGlobalConfiguration')"
        :active.sync="editGlobalConfigurationValue"
      >
        <!-- <form> -->

        <div v-if="isObjectValue" class="w-full">
          <vs-table
            :data="keyValues"
            :description="false"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="thead">
              <th>{{ $t("system.label.Key") }}</th>
              <th>{{ $t("system.label.Value") }}</th>
              <th class="tHeadCenter">{{ $t("system.label.Action") }}</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="keyValues"
                v-for="(valuesPairKeys, index) in data"
              >
                <vs-td>
                  <vs-input
                    :label="$t('system.label.EnterKeyHere')"
                    class="w-full font-semibold mb-2"
                    v-model="valuesPairKeys.key"
                    :id="index"
                    :disabled="valuesPairKeys.disable"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    :id="index"
                    :label="$t('system.label.EnterValueHere')"
                    v-model="valuesPairKeys.value"
                    class="w-full font-semibold mb-2"
                    :disabled="valuesPairKeys.disable"
                  />
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('system.label.Edit')"
                      svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                      @click="editConfigParams(index)"
                      class="icon_row"
                    />
                    <button
                      class="bGNone border-none view_editTable_btn"
                      @click="deleteConfigParams(index)"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        :title="$t('system.label.Delete')"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        class="icon_row"
                      />
                    </button>
                    <feather-icon
                      icon="PlusIcon"
                      :title="$t('system.label.Add')"
                      class="text-warning icon_row"
                      v-if="keyValues.length - index == 1"
                      svgClasses="w-5 h-5 stroke-current cursor"
                      @click="createConfigParams()"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div v-else class="vx-row md:w-full lg:w-full sm:w-full mb-6">
          <div class="vx-col sm:w-full w-full">
            <vs-input
              :label="$t('system.label.Value')"
              type="text"
              class="w-full font-semibold"
              v-model="editValueConfig"
            />
          </div>
        </div>
        <div class="button-container">
          <span class="ml-4 mr-2">
            <vs-button
              icon-pack="feather"
              type="border"
              @click="editGlobalConfigurationValue = false"
            >
              {{ $t("system.label.cancel") }}
            </vs-button>
          </span>
          <span class="ml-1 mr-3">
            <vs-button icon-pack="feather" @click="saveValueConfig">
              {{ $t("system.label.confirm") }}
            </vs-button>
          </span>
        </div>
        <!-- </form> -->
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      showKey: "",
      showValue: "",
      keyValues: [],
      valuesPair: {},
      isObjectValue: false,
      editValueConfig: "",
      createConfigurationPopup: false,
      editGlobalConfigurationValue: false,
      enabledOptions: [true, false],
      name: "",
      enabled: "",
      value: "",
      module: "",
      description: "",
    };
  },

  components: {
    AtomSpinner,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters({
      configurationsData: "configuration/getConfigurationsList",
      ByIdConfigurationsData: "configuration/getByIdConfigurationsDataList",
    }),
  },
  methods: {
    async getConfigurationList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/setConfigurationsList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async updateFlag(id, isEnabled) {
      const payload = { enabled: isEnabled ? "true" : "false" };
      try {
        await this.$store.dispatch(
          "configuration/updateConfigurationFlagAction",
          { id, data: payload }
        );
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async discountTrigger() {
      if (!this.name || !this.value || !this.module || !this.description) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          const payload = {
            discountId: this.$route.params.id,
            name: this.name,
            enabled: this.enabled,

            value: this.value,
            module: this.module,
            description: this.description,
          };

          await this.$store.dispatch(
            "configuration/createConfigurationAction",
            payload
          );
          this.getConfigurationList();
          this.name = "";
          this.enabled = "";
          this.value = "";
          this.module = "";
          this.description = "";

          this.createConfigurationPopup = false;

          // this.$router.push({
          //   name: "DiscountRulesAndRates",
          //   params: { id: this.$route.params.id },
          // });
        } catch (error) {
          const errorMessage = String(error).replace(/^Error:\s*/, "");
          this.$swal({
            title: "Error",
            icon: "error",
            html: `<div style="text-align: center;">${errorMessage}</div>`,
            type: "error",
          });
        }
      }
    },
    async getEventactionMappingList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/setEventactionMappingList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async saveValueConfig() {
      const payload = {
        id: this.ByIdConfigurationsData.id,
      };

      if (this.isObjectValue) {
        const flatObj = {};
        this.keyValues.forEach((el) => {
          flatObj[el.key] = el.value;
          delete el.disable;
        });
        payload.value = JSON.stringify(this.unflattenObject(flatObj));
      } else {
        payload.value = this.editValueConfig;
      }
      try {
        await this.$store.dispatch(
          "configuration/setEditByIdConfigurationsList",
          payload
        );
        this.getConfigurationList();
        this.editGlobalConfigurationValue = false;
        this.resetForm();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    createConfigParams() {
      this.keyValues.push({ key: "", value: "", disable: false });
    },
    editConfigParams(index) {
      this.keyValues[index].disable = false;
    },
    deleteConfigParams: function (index) {
      this.keyValues.splice(index, 1);
    },
    flattenObject(obj, parentKey = "") {
      let result = {};
      for (let key in obj) {
        const value = obj[key];
        const newKey = parentKey ? `${parentKey}.${key}` : key;
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          Object.assign(result, this.flattenObject(value, newKey));
        } else {
          result[newKey] = value;
        }
      }
      return result;
    },
    unflattenObject(data) {
      const result = {};
      for (const flatKey in data) {
        const keys = flatKey.split(".");
        keys.reduce((acc, key, i) => {
          if (i === keys.length - 1) {
            acc[key] = data[flatKey];
            return;
          }
          if (!acc[key]) acc[key] = {};
          return acc[key];
        }, result);
      }
      return result;
    },
    async editGlobalConfigValue(value) {
      this.keyValues = [];

      if (Array.isArray(value.value)) {
        this.editValueConfig = value.value;
        this.isObjectValue = false;
      } else if (typeof value.value === "object") {
        this.keyValues = value.value;
        this.isObjectValue = true;
      } else if (this.isJSON(value.value)) {
        try {
          this.valuesPair = JSON.parse(value.value);
          if (
            typeof this.valuesPair === "number" ||
            typeof this.valuesPair === "boolean" ||
            Array.isArray(this.valuesPair)
          ) {
            this.editValueConfig = value.value;
            this.isObjectValue = false;
          } else {
            const flattened = this.flattenObject(this.valuesPair);
            for (let key in flattened) {
              this.keyValues.push({
                key,
                value: flattened[key],
                disable: true,
              });
            }
            this.isObjectValue = true;
          }
        } catch (e) {
          this.editValueConfig = value.value;
          this.isObjectValue = false;
        }
      } else {
        this.editValueConfig = value.value;
        this.isObjectValue = false;
      }

      let payload = { id: value.id };
      try {
        this.$store.dispatch(
          "configuration/setByIdConfigurationsList",
          payload
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.editGlobalConfigurationValue = true;
    },
    isJSON(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.getConfigurationList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.list-heading1 {
  font-size: 22px;
  font-weight: 500;
}
</style>
